import { ResumeAnalysis } from "lib/resume-scoring/resume-analysis/resume-analyse-types";
import { WorkExperienceScoreAnalysis } from "lib/resume-scoring/types";
import { SectionCard } from "./SectionCard";
import { StatusItem } from "./StatusItem";

export const ExperienceCard = ({
  score,
  maxScore,
  analysis,
  className = "",
}: {
  score: WorkExperienceScoreAnalysis;
  maxScore: number;
  analysis: ResumeAnalysis["workExperiences"];
  className?: string;
}) => {

  const hasGap = score.gap > 0;
  const hasOverlap = score.overlap > 0;
  const gapOrOverlapStatement = hasGap ? "Employment gap" : hasOverlap ? "Employment overlap" : "";
  const gapOrOverlapSubStatement = hasGap ? "Gaps in employment" : hasOverlap ? "Overlaps in employment" : "";
  const criticalIssues = score.statementMistakeCount;
  const warningIssues = score.informationMistakeCount;
  const isEmptyState = analysis.individualWorkExperiencesAnalysis.length === 0;

  return (
    <SectionCard
      title="Experience"
      icon="experience"
      score={Math.floor(score.totalScore)}
      maxScore={maxScore}
      detailsLink="/score-check/experience"
      requiresPremium={true}
      emptyState={isEmptyState}
      className={className}
    >
      <ul className="mb-3 mt-3 gap-y-3 overflow-auto">
        {criticalIssues !== 0 ? (
          <StatusItem
            icon="issue"
            title="Major Issues"
            subtitle="Impacting score"
            status="count"
            count={criticalIssues}
          />
        ) : (
          <StatusItem
            icon="noIssue"
            title="No issue found"
            subtitle="Good impact in score"
            status="success"
          />
        )}

        {warningIssues !== 0 ? (
          <StatusItem
            icon="missingInfoExp"
            title="Missing Info"
            subtitle="Required information missing"
            status="count"
            count={warningIssues}
          />
        ) : (
          <StatusItem
            icon="missingInfoExp"
            title="Information found"
            subtitle="No info is missing"
            status="success"
          />
        )}

        {hasOverlap || hasGap ? (
          <StatusItem
            icon="reverseOrder"
            title={gapOrOverlapStatement}
            subtitle={gapOrOverlapSubStatement}
            status="warning"
          />
        ) : (
          <StatusItem
            icon="reverseOrder"
            title="Correct order detected"
            subtitle="Experience are in correct order"
            status="success"
          />
        )}
      </ul>
    </SectionCard>
  );
};
